import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { Authenticationservice } from '../../services/authentication.service';
import axios from 'axios';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatTableDataSource } from '@angular/material/table';
declare var $: any;
@Component({
  selector: 'app-borrowqueue',
  templateUrl: './borrowqueue.component.html',
  styleUrls: ['./borrowqueue.component.css']
})
export class BorrowqueueComponent implements OnInit, OnDestroy {
  @ViewChild('mytable', { static: false }) Mtable: any;
  @ViewChild('waitforweight', { static: false }) waitforweightTable: any;
  displayedColumns: string[] = ['value', 'selected'];
  dataSourceMat: MatTableDataSource<any>
  BorrowCode: UntypedFormGroup;
  get form() { return this.BorrowCode.controls; }
  userdata: any;
  access = 1;
  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService) {
    this.userdata = this.auth.Authention();
    this.BorrowCode = new UntypedFormGroup({
      oldgroup: new UntypedFormControl('', [Validators.required]),
      newgroup: new UntypedFormControl('', [Validators.required]),
      choosequeue: new UntypedFormControl(),
      chooseloop1: new UntypedFormControl(),
      chooseloop2: new UntypedFormControl(),
      comment: new UntypedFormControl(),
    });
    if (this.userdata.userlevel == 12) {
      this.access = 2;
    }
    else {
      this.access = 1;
    }
  }

  ngOnInit(): void {
    this.goloadqtype();
    this.Laodlistinpath();
    this.Loadallgroup();
    //this.Loadpathcodegroup();
  }
  year_id = '6869';
  sgroup: any[] = ['', {}, {}]
  sloop = ['', '', '']
  txtSearch = [];

  //S_qtype = 1;
  qTypeL: number;
  newGroup: string;

  change_Q() {
    let qtype = this.qTypeL;
    this.chooselist = [];
    this.datagroupinpart = [];
    this.listgroup
    if (qtype == 1 || qtype == 3) this.allGroup = this.allg.filter(el => (el.qtype == 1 || el.qtype == 3));
    else this.allGroup = this.allg.filter(el => (el.qtype == qtype));
    this.loopQSl = this.loopQAll.filter(el => (el.qtype == qtype));
  }

  Snum = 0;
  onCheckboxChange(q_id: number, isSelected: boolean) {
    let data = this.datagroupinpart;
    const item = data.find((d) => d.q_id === q_id);
    if (item) {
      item.selected = isSelected;
    }
    let Snum = data.filter(d => d.selected == true);
    this.forwardlist = String(Snum.map((el: any) => { return el.q_id }));
  }
  hurl = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/'
  // อนุมัติ 
  AcceptAsk(id: any) {
    let url = this.hurl + "app_farmer/approve_borrow_Q?sup_approve=" + this.userdata.supcode + "&id=" + id;
    if (confirm('ต้องการอนุมัติรายการนี้ใช่หรือไม่ ?' + id) == true) {
      axios.post(url).then(res => {
        if (res.data.rowsAffected[0] == 1) { alert('อนุมัติรายการแล้ว'); this.Loadlistwantchangegroupcode(); }
        else {
          { alert('!!+อนุมัติรายการไม่สำเร็จ+!!'); }
        }
      }).catch(err => { throw (err) });
    }
    else { }
  }

  // โหลดข้อมูลกลุ่มทั้งหมด 
  allg: any[] = [];
  allGroup: any[] = [];
  listGroupTo: any[] = [];
  Loadallgroup() {
    this.spinner.show();
    //let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/partcode_group2_w?1=1';
    let url = this.hurl + 'app_farmer/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_partcode_group_2]&w=1=1 order by groupcode';
    axios.get(url).then(res => {
      let data = (res.data);
      this.allg = data;
      this.allGroup = data.filter(el => ((el.qtype == this.qTypeL) || (el.supzone == 'CT')));;
      this.listgroup = data.filter(el => ((el.Partcode == this.userdata.zonedata) || (el.Partcode_b == this.userdata.zonedata)));
      this.spinner.hide();
    }).catch(err => { throw (err) });
  }

  // โหลดกลุ่มในส่วน
  listgroup: any[] = [];
  Loadpathcodegroup() {
    let zone = this.userdata.zonedata;
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/brdsqlapi/partcode_group_w?partcode=" + this.userdata.zonedata
    let url = `${this.hurl}app_farmer/select_s_f_w_0?s=*&f=dbQBRD.dbo.[v_partcode_group]&wpartcode='${zone}'`

    axios.get(url)
      .then(res => {
        this.listgroup = res.data;
      }).catch(err => { throw err })
  }

  // โหลดข้อมูลรออนุมัติ
  alllist: any[] = [];
  Loadlistwantchangegroupcode() {
    this.spinner.show();
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_v_borrow_Q?qtype=${this.qTypeL}`;
    let url = `${this.hurl}app_farmer/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_borrow_Q]&w=qtype=${this.qTypeL}`;
    axios.get(url).then(res => {
      this.alllist = (res.data);
      this.spinner.hide();
    }).catch(err => { throw (err) });
  }

  // โหลดรอบคิว
  loopQSl: any[] = [];
  loopQAll: any[] = [];
  goloadqtype() {
    this.spinner.show();
    //let url = `https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_loop_id_by_qtype?qtype=${this.qTypeL}`;
    let url = `${this.hurl}app_farmer/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_loop_q]&w=1=1`;
    axios.get(url).then(res => {
      this.spinner.hide();
      let data = res.data;
      data.sort(function (b, a) { return a.loop_id - b.loop_id });
      this.loopQAll = data;
    }).catch(err => { console.log(err) })
  }

  // โหลดข้อมูลคิวในกลุ่มแต่ละกลุ่มในส่วนของตัวเอง
  datagroupinpart: any[] = [];
  LoadQueueinGroup() {
    let group = this.sgroup[1].groupcode;//this.BorrowCode.get('oldgroup').value;
    let loop = this.sloop;
    console.log('BorrowCode:', group, loop);
    let url = '';
    url = `${this.hurl}app_farmer/select_s_f_w_0?s=[q_id],[truck_type]&f=[dbQBRD].[dbo].[v_barcodeloopQ]&w=[qtype]=${this.qTypeL}and[ck_used]=1and [groupcode]='${group}'and[loop_id]between'${loop[1]}'and'${loop[2]}'group by[q_id],[truck_type] `
    axios.get(url)
      .then(res => {
        let data = res.data;
        data.forEach(item => {
          item.selected = false;
        });
        data.sort(function (a, b) { return a.q_id - b.q_id; });
        console.log('datagroupinpart;', data)
        this.datagroupinpart = data;
        this.dataSourceMat = new MatTableDataSource<any>(data);
        //this.datagroupinpart = data;//data.filter((v, i, a) => a.findIndex(t => (t.q_id == v.q_id)) == i);
        //this.sum_sv = data.map(function (el) { return el.q_id });
      }).catch(err => { throw err })
  }


  // รายการที่เลือก
  chooselist: any[] = [];
  forwardlist = '';
  lastid = 0;
  SelectList(loop: any, qid: any) {
    // let fmcode = {'fmcode': data , 'fmname': fmname ,'dateupdate': date};
    this.lastid = this.lastid + 1
    let data = { 'loop_id': loop, 'q_id': qid, 'id': this.lastid };
    this.chooselist.push(data);
    this.chooselist = this.chooselist.sort(function (a, b) { return a.id - b.id });
    this.chooselist = this.chooselist.filter((v, i, a) => a.findIndex(t => (t.q_id == v.q_id)) == i);
    //console.log('chooselist:', this.chooselist);

    let new_list = this.chooselist.map(function (obj) {
      return {
        loop_id: obj.loop_id,
        q_id: obj.q_id,
      }
    });
    let starttistop = (new_list.map((el: any) => { return el.loop_id }));
    let queuelist = (new_list.map((el: any) => { return el.q_id }));
    this.forwardlist = String(queuelist);

  }

  // ลบข้อมูล
  deletesomevalue(id: any) {
    // console.log(fmcode);
    let data = this.chooselist.filter(el => (el.id != id));
    this.chooselist = data.sort(function (a, b) {
      return a.id - b.id;
    });
    let new_list = this.chooselist.map(function (obj) {
      return {
        loop_id: obj.loop_id,
        q_id: obj.q_id,
      }
    });
    let queuelist = (new_list.map((el: any) => { return el.q_id }));
    this.forwardlist = String(queuelist);
    // localStorage.setItem('fmcodedataforcredit',JSON.stringify(this.choosedata).toString());
  }

  // ตรวจสอบคิวก่อนย้าย
  listqueue = [];
  CheckLoopQueue() {
    let loop = this.sloop;
    const group = this.sgroup;
    const gp = ['', group[1].groupcode, group[2].groupcode];

    let url = `${this.hurl}app_farmer/v_barcodeloopQ_v5?Qtype=${this.qTypeL}&groupcode1=${gp[1]}&groupcode2=${gp[2]}&loop1=${loop[1]}&loop2=${loop[2]}&q_id=${this.forwardlist}`;
    //console.log(url);
    console.log('BorrowCode:', group, loop);
    axios.get(url)
      .then(res => {
        this.listqueue = res.data;
        $('#QueueChange').modal('show');
      }).catch(err => { throw err })
  }

  // อัพเดทรายการ
  UpdateSelectQueueV5() {
    let loop = this.sloop;
    const group = this.sgroup;
    //const gp = ['', group[1].groupcode, group[2].groupcode];
    let url = `${this.hurl}function-3/update_t_s_w?`
      + `t=dbQBRD.dbo.v_barcodeloopQ`
      + `&s=groupcode='${group[2].groupcode}' ,qtype=${group[2].qtype}, group_q=${group[2].qtype}`
      + `&w=qtype=${this.qTypeL} and ck_qcard=1 and groupcode='${group[1].groupcode}' and loop_id between'${loop[1]}'and'${loop[2]}'and q_id in(${this.forwardlist})`
    //console.log(url);
    axios.put(url)
      .then(res => {
        if (res && res.status === 200) {
          alert('บันทึกคำขอแล้ว');
          this.InsertAskforQueue();
        }
        else {
          alert('!!++บันทึกคำขอไม่สำเร็จ ++!!');
        }
      })
      .catch(err => { throw err })
  }

  // เพิ่มรายการย้ายคิว
  InsertAskforQueue() {
    let loop = this.sloop;
    let group = this.sgroup;
    let url = `${this.hurl}app_farmer/insert_borrow_Q?`
      + "year_id='" + this.year_id + "'"
      + "&qtype=" + group[1].qtype
      + "&from_groupcode='" + group[1].groupcode + "'"
      + "&to_groupcode='" + group[2].groupcode + "'"
      + "&start_loop='" + loop[1] + "'"
      + "&end_loop='" + loop[2] + "'"
      + "&q_id='" + this.forwardlist + "'"
      + "&supcode='" + this.userdata.supcode + "'"
      + "&supzone='" + this.userdata.zonedata + "'"
      + "&comment='" + (group[0] || '') + "'"
      + "&status=1";
    axios.post(url)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('บันทึกคำขอแล้ว');
          //this.BorrowCode.reset();
          this.forwardlist = '';
          this.chooselist = [];
          this.datagroupinpart = [];
          this.listqueue = [];
          this.CloseModal();
          this.Laodlistinpath();
        }
        else {
          alert('!!++บันทึกคำขอไม่สำเร็จ ++!!');
        }
      })
      .catch(err => { throw err })
  }

  // โหลดข้อมูลในส่วนของตัวเอง
  inpathdata: any[];
  Laodlistinpath() {//
    let url = `${this.hurl}app_farmer/select_s_f_w_0?s=*&f=[dbQBRD].[dbo].[v_borrow_Q]&w=[year_id]='${this.year_id}'and[supzone]='${this.userdata.zonedata}' order by[dateadd]desc`
    //let url = "https://asia-southeast2-brr-farmluck.cloudfunctions.net/app_farmer/select_v_borrow_Q?supzone=%27" + this.userdata.zonedata + "%27"
    axios.get(url)
      .then(res => {
        let data = res.data;
        data.forEach(item => {
          item.q_idj = item.q_id.split(',').map(Number);
        });
        this.inpathdata = data;
      }).catch(err => { throw err });
  }

  // ยกเลิกคำขอย้ายคิวกลุ่ม
  Cancleaskchange(id: any) {
    let url = `${this.hurl}app_farmer/canceled_borrow_Q?id=` + id;
    axios.post(url)
      .then(res => {
        if (res.data.rowsAffected[0] == 1) {
          alert('ยกเลิกคำขอแล้ว');
          this.Laodlistinpath();
        }
        else {
          alert('!!++ยกเลิกคำขอไม่สำเร็จ ++!!');
        }
      })
      .catch(err => { throw err })
  }

  CloseModal() {
    $('#QueueChange').modal('hide');
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    //this.BorrowCode.reset();
    this.forwardlist = null;
    this.chooselist = [];
    this.datagroupinpart = [];
    this.listqueue = null;
  }


}
